import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/store/app.state';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectIsAuthenticated } from '../store/userAuth/userAuth.selectors';
import { TokenStorageService } from '@app/core/services/token-storage.service';

@Injectable({
  providedIn: 'root'
})

export class UserAuthGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private tokenStorageService: TokenStorageService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(selectIsAuthenticated).pipe(
      take(1),
      map((isAuth) => {
        // const hasToken = !!this.tokenStorageService.getToken();
        // const isAuthenticated = isAuth || hasToken;
        const isAuthenticated = isAuth;

        if (!isAuthenticated) {
          sessionStorage.setItem('returnUrl', state.url);
          this.router.navigate(['/portal-login']);
        }
        return isAuth;
      })
    );
  }
}
